import React, { useMemo, memo } from 'react';
import { prop, compose } from 'ramda';
import { clsx } from 'js/utils/classNames.util';
import { useDeviceSelector } from 'js/store/hooks';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';

import * as Types from './types';
import { MobileHeader } from './components/MobileHeader';
import { DesktopHeader } from './components/DesktopHeader';

import style from './DefaultHeader.scss';

export const DefaultHeaderBare: React.FC<Types.DefaultHeaderProps> = ({ className, classname }) => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const classNames = useMemo((): string => clsx([
        classname, className, style.defaultHeader, 'page-header'
    ]), [className, classname]);

    return (
        <header className={`${classNames} cms-default-header`}>
            {isDesktop
                ? <DesktopHeader />
                : <MobileHeader />
            }
        </header>
    );
};

export const DefaultHeader = compose(
    memo,
    withComponent({ tkPrefix: 'playtech.mobile.system.' })
)(DefaultHeaderBare);

componentService.registerWebContentComponents({ DefaultHeader });
